import { render, staticRenderFns } from "./ReservationUpdatePage.vue?vue&type=template&id=2b19a143"
import script from "./ReservationUpdatePage.vue?vue&type=script&lang=js"
export * from "./ReservationUpdatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports